var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Neuer Sektor",
        visible: _vm.$parent.showFieldForm,
        width: "300px"
      },
      on: {
        "update:visible": function($event) {
          return _vm.$set(_vm.$parent, "showFieldForm", $event)
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      class: [_vm.form.error ? "is-error" : ""],
                      attrs: {
                        label: "Anzahl Einheiten",
                        prop: "number_of_panels"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Anzahl Einheiten" },
                        nativeOn: {
                          keyup: function($event) {
                            return _vm.validateNumber(_vm.form.number_of_panels)
                          }
                        },
                        model: {
                          value: _vm.form.number_of_panels,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "number_of_panels", $$v)
                          },
                          expression: "form.number_of_panels"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitForm("form")
                }
              }
            },
            [
              _vm._v("\n            Bestätigen\n            "),
              _vm.formSubmitted
                ? _c("i", { staticClass: "el-icon-loading" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.closeForm } }, [
            _vm._v("Abbrechen")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03e89f3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e89f3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/fields/FieldForm.vue
// module id = null
// module chunks = 